import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

const slice = createSlice({
	name: "newMessageDropdown",
	initialState: {
		notifications: [],
		seen:true,
	},
	reducers: {
		newMessageRecieved : (state,action)=>{
			state.notifications.push(action.payload)
			state.seen = false
		},
		updateSeen : (state,action)=>{
			state.seen = action.payload
		},
		clear : state => { 
			state.notifications = [] 
			state.seen = true
		}
	},
	extraReducers: {},
})

export const {
	newMessageRecieved,
	updateSeen,
	clear
} = slice.actions

export const selectSeen = state => state.newMessageDropdown.seen
export const selectNotifications = state => state.newMessageDropdown.notifications

export default slice.reducer
